import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'

import { ANTICIPATION_FILTER, ANTICIPATION, FILTER_MODE_UPDATE } from '../../../constants/commons'
import * as f from '../../../classes/Filters'
import * as TLM from '../../../constants/tlm'

class AnticipationMediaTypeFilterComponent extends React.Component {
  static propTypes = {
    setFilters: PropTypes.func.isRequired,
    filters: PropTypes.object.isRequired,
    selectedPlanFilters: PropTypes.object,
    module: PropTypes.string.isRequired
  }

  constructor (props) {
    super(props)

    this.state = {
     anticipationFilters: this.props.selectedPlanFilters.anticipationFilters || this.props.filters
    }
  }

  componentDidUpdate (prevProps) {
    if (prevProps.selectedPlanFilters.anticipationFilters !== this.props.selectedPlanFilters.anticipationFilters) {
      this.setState({ anticipationFilters: this.props.selectedPlanFilters.anticipationFilters})
    }
  }

  render () {
    return (
      <>
        <ul className="checkList">
          <li><h4>Media Type Filters (OR)</h4></li>
          {this.li(TLM.MOVIE, TLM.MOVIE)}
          {this.li(TLM.SHOW, TLM.SHOW)}
        </ul>
      </>
    )
  }

  li = (filter, text) => {
    // let currentValue = this.props.filters && !this.props.filters.equals(DefaultFilters) && this.props.filters.filters.find(f => f.topic_sub_type === filter)
    let currentValue = this.props.filters && this.props.filters.filters.find(f => f.topic_sub_type === filter)
    const value = currentValue ? true : false
    return (
      <li>
        <input
          type="checkbox" id={`${text}`}
          checked={value}
          onChange={this.filterByTopicSubtype.bind(this, filter)} />
        <span></span>
        <label htmlFor={`${text}`}>{text}</label>
      </li>
    )
  }

  filterByTopicSubtype = (type) => {
    let filters = this.state.anticipationFilters
    let filter = null

    if (type === TLM.SHOW || type === TLM.MOVIE) {
      filter = new f.Filter({
        topic_sub_type: type,
        date_range: new f.FilterDateRange({
          start_date: moment(new Date()).format('YYYY-MM-DD')
        })
      })
    } else if (type === TLM.VIDEO) {
      filter = new f.Filter({
        topic_sub_type: type,
        topic_name_match: f.ANTICIPATION_VIDEO_REGEX
      })
    }

    filters = filters ? filters.toggle(filter) : new f.Filters([ filter])

    this.props.setFilters(filters, ANTICIPATION_FILTER, ANTICIPATION, FILTER_MODE_UPDATE)
  }
}

export default AnticipationMediaTypeFilterComponent